interface IconProps {
  className?: string
}

export const MailIcon = ({ className }: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M 3.7600376,10.699823 V 5.8461934 l 4.24,2.82667 4.2400504,-2.82667 v 4.8536296 c 0,0.1522 -0.1467,0.34 -0.4,0.34 H 4.1600376 c -0.25331,0 -0.4,-0.1878 -0.4,-0.34 z'
      fill='currentColor'
    />
    <path
      d='m 8.0000376,7.3267934 -3.55044,-2.36697 h 7.1008904 z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m 15.995277,16.000023 0.0047,-0.0058 V 0.0045962 L 15.997177,0 H 0.00342601 L 0,0.0034298 V 15.994223 l 3.9225921e-4,0.0058 z M 2.6400376,5.3598234 c 0,-0.83947 0.68053,-1.52 1.52,-1.52 h 7.6800504 c 0.8394,0 1.52,0.68053 1.52,1.52 v 5.3399996 c 0,0.8378 -0.7174,1.46 -1.52,1.46 H 4.1600376 c -0.80268,0 -1.52,-0.6222 -1.52,-1.46 z'
      fill='currentColor'
    />
  </svg>
)
